import React, { Component } from 'react'

export default class NumberInput extends Component {
    state = {
        value: this.props.value,
        disabled: this.props.disabled
    }

    static getDerivedStateFromProps(props, state) {
        return {
            disabled: props.disabled,
            value: props.value
        };
    }

    render() {
        return (
            <input 
                disabled={this.state.disabled}  
                type="number" 
                step={this.props.step} 
                min={this.props.min} 
                max={this.props.max}
                onChange={(e)=>{
                    let value = e.target.value;

                    this.setState({
                        value
                    });

                    if (this.props.handleChange !== undefined)
                        this.props.handleChange(value);                    
                }}

                onBlur={(e)=>{
                    let value = parseFloat(e.target.value);
                    let min = parseFloat(this.props.min), max =  parseFloat(this.props.max);

                    if(!isNaN(min))
                        value = Math.max(min, value);
                    if(!isNaN(max))
                        value = Math.min(value, max);

                    if(this.props.digits)
                        value = value.toFixed(this.props.digits)

                    this.setState({value});

                    if (this.props.handleChange !== undefined)
                        this.props.handleChange(value);
                }}

                value={this.state.value}
            >
            </input>  
        );
    }
}
